import { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { SelectedPlan } from '../../components/common/VirtualOfficeSubscription/SelectedPlan';
import { dateDifferenceInDaysFromToday } from '../../helpers/helperFunctions';
import { H2, H3, H4, P2 } from '../../styles/FontStyles';
import { useAppSelector } from '../../app/hooks';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { getUserTickets } from '../../slices/auth-slice';
import { useDispatch } from 'react-redux';
import { VirtualOfficeGrid } from '../../components/common/VirtualOfficeSubscription/VirtualOfficeGrid';
import { colors } from '../../styles/GlobalStyles';
import { AnimatedDashboard } from '../../components';
import { getLicenses } from '../Settings/Settings.actions';

export const ChooseSubscription = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState();
  const [step, setStep] = useState(1);
  const { user, licences } = useAppSelector((state) => state.settings);
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserTickets());
    dispatch(getLicenses());
  }, [dispatch]);

  return (
    <AnimatedDashboard zoom dark key={'chooseSubscription'}>
      <PageTitle center>Choose your BackOffice Subscription</PageTitle>
      <div>
        <Flexed between mt='50' rowSM>
          <Flexed
            width={licences?.length == 3 ? '35%' : '50%'}
            widthSM='100%'
            column>
            <H3 color={colors.primary900}>BackOffice Subscription</H3>
            <P2 mb='25' mt='5' color={colors.neutral900}>
              United One Back Office is your access to many exclusive
              opportunities to earn, connect and learn among the community of
              business oriented individuals.
            </P2>
          </Flexed>

          <Flexed width={licences?.length == 3 ? '65%' : '50%'} widthSM='100%'>
            <VirtualOfficeGrid
              setSelected={setSelected}
              setIsOpen={setIsOpen}
              setStep={setStep}
              licences={licences}
            />
          </Flexed>
        </Flexed>

        <SidebarModal
          isOpen={isOpen}
          setOpen={setIsOpen}
          title={t('virtual_office.backoffice_subscription')}
          sidebarWidth={'600px'}>
          <SelectedPlan
            selected={selected}
            setSelected={setSelected}
            step={step}
            setStep={setStep}
          />
        </SidebarModal>
      </div>
    </AnimatedDashboard>
  );
};
